/**
 * @description 商品类接口
 */
import request from '@/utils/request'

// 获取商品列表
// data = { category_id: '' }
export const list = data => (request({
  method: "POST",
  url: "goods/get_list",
  data
}))

// 获取商品分类
export const category = () => (request({
  method: "POST",
  url: "goodscategory/get_list"
}))